module.exports = __webpack_public_path__ + "images/choices/mydreamplus-f7e6ef8cdf5ee83374ccdc739df9ab9e.png";